module.exports = __webpack_public_path__ + "media/images/dividend/ill-coupon-f52ccedbd24a0ef83bf7820f66392eea.svg";